// extracted by mini-css-extract-plugin
var _1 = "CourseTestSection_content__814b3";
var _2 = "CourseTestSection_footer__230ef";
var _3 = "CourseTestSection_root__ab8c5";
export { _1 as "content", _2 as "footer", _3 as "root" }
